"use client";

import Link from "next/link";
import { usePathname } from "next/navigation";
import { useEffect, useRef, useState } from "react";

const categories = [
    "WWE",
    "World",
    "Politics",
    "Business",
    "Tech",
    "Health",
    "Opinions",
    "Sports",
    "Style",
    "Food",
    "Travel",
    "History",
];

const adminLinks = [
    { label: "Posts", href: "/admin/posts" },
    { label: "New Post", href: "/admin/editor/new" },
];

export default function MainNavBar() {
    const pathname = usePathname();
    const scrollRef = useRef(null);
    const [showFade, setShowFade] = useState({ left: false, right: false });

    useEffect(() => {
        const el = scrollRef.current;
        if (!el) return;

        const updateFades = () => {
            setShowFade({
                left: el.scrollLeft > 0,
                right: el.scrollLeft + el.clientWidth < el.scrollWidth - 1,
            });
        };

        updateFades();
        el.addEventListener("scroll", updateFades);
        return () => el.removeEventListener("scroll", updateFades);
    }, []);

    const isAdmin = pathname.startsWith("/admin");
    const links = isAdmin
        ? adminLinks.map(({ label, href }) => ({ label, slug: href }))
        : categories.map((cat) => ({
              label: cat,
              slug: `/categories/${cat.toLowerCase()}`,
          }));

    return (
        <nav className="relative w-full overflow-hidden bg-white dark:bg-zinc-950 border-b border-gray-200 dark:border-zinc-800">
            {/* Scroll shadows */}
            {showFade.left && (
                <div className="absolute left-0 top-0 h-full w-6 bg-gradient-to-r from-white dark:from-zinc-950 to-transparent pointer-events-none z-10" />
            )}
            {showFade.right && (
                <div className="absolute right-0 top-0 h-full w-6 bg-gradient-to-l from-white dark:from-zinc-950 to-transparent pointer-events-none z-10" />
            )}

            <div className="max-w-screen-xl mx-auto px-4 sm:px-6">
                <div
                    ref={scrollRef}
                    className="overflow-x-auto no-scrollbar flex justify-start lg:justify-center"
                    style={{ scrollBehavior: "smooth" }}
                >
                    <ul className="inline-flex gap-6 py-3 min-w-max pl-4 pr-4">
                        {links.map(({ label, slug }) => {
                            const isActive =
                                pathname === slug ||
                                pathname.startsWith(slug + "/");
                            return (
                                <li key={slug} className="flex-shrink-0">
                                    <Link
                                        href={slug}
                                        className={`text-sm sm:text-base font-medium px-2 py-1 transition-colors duration-150 ${
                                            isActive
                                                ? "text-blue-600"
                                                : "text-gray-700 dark:text-gray-300 hover:text-blue-600"
                                        }`}
                                    >
                                        {label}
                                    </Link>
                                </li>
                            );
                        })}
                    </ul>
                </div>
            </div>
        </nav>
    );
}
